export const isCoordinador = (user) => {
  return ["admin", "coordinador"].includes(user?.permiso);
};

export const notCliente = (user) => {
  return !["invitado", "cliente"].includes(user.permiso);
};
